var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { redirectToStaticPage } from '../app/actions.web';
import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import { JitsiConferenceErrors, JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { SET_DETAILS } from './actionTypes';
import { STATUSES } from './constants';
import logger from './logger';
/**
 * The redux middleware for jaas.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => (action) => __awaiter(void 0, void 0, void 0, function* () {
    switch (action.type) {
        case CONFERENCE_JOINED: {
            const { conference } = action;
            if (store.getState()['features/base/config'].iAmRecorder) {
                // We don't register anything on web if we are in iAmRecorder mode
                return next(action);
            }
            conference.on(JitsiConferenceEvents.CONFERENCE_ERROR, (errorType, errorMsg) => {
                errorType === JitsiConferenceErrors.SETTINGS_ERROR && logger.error(errorMsg);
            });
            break;
        }
        case SET_DETAILS: {
            const { status } = action.payload;
            if (status === STATUSES.BLOCKED) {
                store.dispatch(redirectToStaticPage('/static/planLimit.html'));
            }
            break;
        }
    }
    return next(action);
}));
